import { render, staticRenderFns } from "./EventTitle.vue?vue&type=template&id=70bd990b&"
import script from "./EventTitle.vue?vue&type=script&lang=js&"
export * from "./EventTitle.vue?vue&type=script&lang=js&"
import style0 from "./EventTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports